/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/BLVSH/"

const BLVSH: CommunityData = {
  code: "blvsh",
  name: "BLVSH",
  inviteCode: "blvsh",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/blv-801`,
  defaultCurrency: "EUR",
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#ebf0ef",
      hero: {
        desktop: `https://media.werz.at/community-assets/BLVSH/coming-soon-hero.jpg`,
        mobile: `https://media.werz.at/community-assets/BLVSH/coming-soon-hero.jpg`,
        style: "bg-[#cad8d6]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[97px] h-[64px] sm:w-[146px] sm:h-[96px]",
      },
      werzLogoColor: "#191818",
      title: "font-['SangBleuEmpire'] text-[28px] leading-[120%] text-[#0c5046]",
      text: "font-['SangBleuEmpire'] text-[16px] leading-[120%] text-[#0c5046]",
      button:
        "font-['InterRegular'] text-[16px] leading-[120%] p-4 bg-[#ffffff] border border-[#4d827a] text-[#4d827a] cursor-pointer w-fit",
      input: {
        base: "font-['SangBleuEmpire'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#0c5046]",
        border: "#D4D4D4",
        borderFocus: "#0c5046",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['SangBleuEmpire'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['SangBleuEmpire'] text-[14px] leading-[120%] text-[#4d827a]",
      skipButton:
        "font-['SangBleuEmpire'] text-[14px] leading-[120%] text-[#4d827a] cursor-pointer",
      modal: {
        container: "bg-[#dce5e3] px-[40px] py-[48px]",
        title: "font-['SangBleuEmpire'] text-[24px] leading-[120%] text-[#0c5046] text-center",
        text: "font-['SangBleuEmpire'] text-[14px] leading-[120%] text-[#4d827a] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#0c5046] bg-white font-['SangBleuEmpire'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#0c5046",
      },
    },
    global: {
      counterColor: "#0c5046",
      logo: {
        src: "https://media.werz.at/community/icon/cmgrlwedt00019kn4pf93g525.jpg?uploadTime=1760520779130&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[170px] h-[112px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ebf0ef",
      asideBg: "#ebf0ef",
      asideStyles: "border-r border-[#4d827a]",
      contentBg: "#ebf0ef",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['SangBleuEmpire']",
      primaryButton:
        "bg-[#ffffff] border border-[#4d827a] px-[18px] py-[18px] !text-[#4d827a] font-['InterRegular'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#0c5046",
      sideBarSeparator: "border-r-[1px] border-[#acc8c4]",
      separator: "border-[#acc8c4]",
      item: "font-['SangBleuEmpire'] text-[16px] text-[#0c5046] text-left leading-[120%] gap-x-[10px] text-opacity-50 text-center border-b border-[#acc8c4] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ebf0ef] !pb-8",
      titles: "text-[#0c5046] font-['SangBleuEmpire'] text-[26px] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#4d827a] font-['SangBleuEmpire'] text-[13px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#acc8c4]",
        sectionTitle:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ebf0ef]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] text-left leading-[120%]",
          subtitle:
            "text-[#4d827a] font-['SangBleuEmpire'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#acc8c4]",
        sectionTitle:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[26px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ebf0ef]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] text-left leading-[120%]",
          subtitle:
            "text-[#4d827a] font-['SangBleuEmpire'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#4d827a] font-['SangBleuEmpire'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#4d827a] font-['SangBleuEmpire'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#0c5046] font-['SangBleuEmpire'] text-[22px] text-left leading-[120%]",
        text: "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[26px] text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/BLVSH/web-background-non-member.png",
      bgMobile: "https://media.werz.at/community-assets/BLVSH/web-background-non-member.png",
      bgColor: "#ebf0ef",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ebf0ef]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#0c5046]",
        name: "text-[#0c5046] font-['SangBleuEmpire¶'] text-[26px] leading-[31.2px] text-center text-center mt-4 mb-1",
        location:
          "font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#0c5046",
        button:
          "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] text-[#0c5046] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebf0ef] border border-[#0c5046] text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ebf0ef] border border-[#0c5046]",
          title: "font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left text-center mb-1",
          text: "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center text-center",
          button:
            "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] text-[#0c5046] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ebf0ef] border border-[#0c5046]",
          duration:
            "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#0c5046",
          media: "overflow-hidden m-2 border border-[#0c5046]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ebf0ef] border border-[#0c5046]",
          name: "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#4d827a] border border-[#4d827a] text-[#ffffff] font-['SangBleuEmpire¶'] text-[15px] uppercase leading-[18px] text-center",
          duration:
            "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          location:
            "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] text-[#0c5046] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#0c5046]",
            name: "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[18px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[18px] text-[14px] text-left",
            link: "text-[#4d827a] font-['SangBleuEmpire¶'] text-[13px] leading-[15.6px] text-left",
            status: "text-[#0c5046] font-['SangBleuEmpire'] leading-[120%] text-[14px] text-left",
            button:
              "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] text-[#0c5046] font-['InterRegular'] text-[14px] text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebf0ef] border border-[#0c5046] text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center",
        header:
          "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ebf0ef] border border-[#0c5046]",
          name: "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#0c5046",
          created: "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#0c5046]",
        },
        seeAllNews:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebf0ef] border border-[#0c5046] text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center",
        header:
          "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ebf0ef] border border-[#0c5046]",
          coverUrl: "overflow-hidden m-2 border border-[#0c5046]",
          duration:
            "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          liveType:
            "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#0c5046] rounded-full",
          playIconColor: "#0c5046",
          playIconBackgroundColor: "#FFFFFF",
          playIconBorderColor: "#0c5046",
          start: "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebf0ef] border border-[#0c5046] text-[#0c5046] font-['SangBleuEmpire'] text-[15px] leading-[120%] text-center",
        header:
          "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ebf0ef] border border-[#0c5046]",
          name: "text-[#0c5046] font-['SangBleuEmpire¶'] leading-[24px] text-[16px] text-left",
          triangleIconColor: "#0c5046",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#0c5046]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#4d827a] font-['SangBleuEmpire¶'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ebf0ef] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#acc8c4]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#0c5046] font-['SangBleuEmpire'] text-[26px] text-left leading-[120%]",
        subtitle:
          "text-[#4d827a] font-['SangBleuEmpire'] text-[13px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#4d827a] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#4d827a] font-['InterRegular'] !text-[16px] text-left",
        questions: "text-[13px] text-left leading-[120%] text-[#0c5046]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#acc8c4]",
        header: "text-[#0c5046] font-['SangBleuEmpire'] text-[22px] text-left leading-[120%]",
        text: "text-[#0c5046] font-['SangBleuEmpire'] text-[13px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#acc8c4]",
        header: "text-[#0c5046] font-['SangBleuEmpire'] text-[22px] text-left leading-[120%]",
        text: "text-[#0c5046] font-['SangBleuEmpire'] text-[13px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#4d827a] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#0c5046] font-['SangBleuEmpire'] text-[22px] text-left leading-[120%]",
        text: "text-[#0c5046] font-['SangBleuEmpire'] text-[13px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#0c5046] font-['SangBleuEmpire'] text-[22px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ebf0ef] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] text-[#0c5046] font-['InterRegular'] text-[14px] text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ebf0ef] border-b border-[#acc8c4] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#0c5046] font-['SangBleuEmpire'] text-[15px] text-left leading-[120%] mb-1",
          description:
            "text-[#4d827a] font-['SangBleuEmpire'] text-[13px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#4d827a] font-['SangBleuEmpire'] text-[15px] text-left leading-[120%]",
          quantity: "text-[#0c5046] font-['InterRegular'] text-[14px] text-left",
          status: "text-[#4d827a] font-['SangBleuEmpire'] text-[15px] text-left leading-[120%]",
          counterContainer:
            "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border border-[#4d827a] px-[16px] py-[12px] text-[#0c5046] font-['InterRegular'] text-[14px] text-left !w-fit",
          plusMinusColor: "#0c5046",
        },
      },
    },
  },
}

export default BLVSH
